export default __webpack_public_path__ + "static/media/imageTum4.60e0dba1.jpg";